import React, { useContext } from 'react';
import Context from '@bibliocommons/context';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import { IconButton } from '@bibliocommons/base-buttons';
import { Share, Print } from '@bibliocommons/base-icons';
import BackToLink from 'app/components/shared/BackToLink';
import FeatureTogglz from '../FeatureTogglz';

import './HeaderBar.scss';

export default function HeaderBar() {
  const { mobileApp } = useContext(Context);
  if (mobileApp) return null;

  return (
    <div className="cp-header-bar">
      <BackToLink />
      <FeatureTogglz>
        {features =>
          features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? (
            <div className="print-share-buttons">
              <IconButton className="print-button" dataKey="print-button">
                <Print />
              </IconButton>
              <IconButton className="share-button" dataKey="share-button">
                <Share />
              </IconButton>
            </div>
          ) : null}
      </FeatureTogglz>
    </div>
  );
}
